module.exports = __webpack_public_path__ + "static/HIW3-065c82a4ac2d49bcadef0f755425de81.svg";